export default __webpack_public_path__ + "static/media/LogoITDC.0c03e31a.png";